@if (items?.length || hiddenResultsPreview?.length) {
  @if (hasTitle && title) {
    <div layout-horizontal margin-bottom>
      <rt-heading
        (click)="toggle()"
        class="expand-completed"
        variant="heading space-bottom text-color"
      >
        <rt-icon [name]="state.expanded ? 'expand-more' : 'expand-less'" [size]="'medium'">
        </rt-icon>
        {{ title }}
      </rt-heading>
      @if (offer && hasMoreThanOneJob) {
        <rt-divider variant="dot"></rt-divider>
        {{ offer.title }}
      }
      <div
        class="evaluation-rating"
        layout-horizontal
        layout-align-items-center
        layout-flex-1
        layout-justify-flex-end
      >
        @if (hasRating()) {
          <span>{{
            (hiddenResultsPreview?.length
              ? 'app.interview.hidden_score'
              : 'app.interview.positive_rate'
            ) | translate
          }}</span>
          @if (hiddenResultsPreview?.length) {
            <rt-icon [name]="'visibility-off'" margin-left-small-x></rt-icon>
          }
          @if (!hiddenResultsPreview?.length) {
            <rt-interview-evaluation-rating
              [rating]="rating!"
              [size]="'small'"
            ></rt-interview-evaluation-rating>
            <strong>{{ rating }}%</strong>
          }
        } @else {
          <div>{{ 'app.interview.no_score' | translate }}</div>
        }
      </div>
    </div>
  }
  <div [class.hidden]="!state.expanded" [class.short]="short" layout-vertical>
    @if (hiddenResultsPreview?.length) {
      @for (
        hiddenResultPreview of hiddenResultsPreview;
        track trackByValue($index, hiddenResultPreview)
      ) {
        <rt-hidden-evaluations-infobox
          [guests]="hiddenResultPreview.guests"
          [admins]="$any(hiddenResultPreview.admins)"
          [count]="hiddenResultPreview.count"
          [offer]="hiddenResultPreview.offer"
          [stage]="$any(hiddenResultPreview.stage)"
          [isJobNameVisible]="hiddenEvaluationsJobNameVisible"
          [isButtonsVisible]="
            groupBy !== 'stage' ||
            isCurrentStage(hiddenResultPreview.offer, hiddenResultPreview.stage)
          "
          [groupBy]="groupBy"
          [short]="false"
          [offers]="state.offers"
          [templates]="state.templates"
          [candidateId]="candidateId"
          [canReviewHiddenEvaluations]="abilities.reviewHiddenEvaluations"
          [hasAccessToJob]="hasAccessToJob(hiddenResultPreview.offerId)"
          [totalOffersCount]="this.candidatePlacements?.length || 0"
          (quickEvaluationClick)="quickEvaluationClick.emit($event)"
          margin-bottom-small
        ></rt-hidden-evaluations-infobox>
      }
    }
    @if (items?.length) {
      @for (item of items; track trackById($index, item)) {
        @switch (type) {
          @case ('request') {
            <rt-interview-result-request-card
              [currentAdmin]="state.currentAdmin!"
              [openCandidateOnClick]="true"
              [openEventModalOnClick]="openEventModalOnClick"
              [inCandidate]="inCandidate"
              [request]="$any(item)"
              [short]="short"
              [inDashboard]="inDashboard"
              [candidateId]="item.candidate?.id"
              [hasHighLevelDataAccess]="abilities.highLevelDataAccess"
              [dialogRef]="dialogRef"
            >
            </rt-interview-result-request-card>
          }

          @case ('result') {
            <rt-interview-result-card
              [currentAdmin]="state.currentAdmin!"
              [result]="$any(item)"
              [edit]="edit"
              [candidate]="item.candidate"
              [hasHeader]="hasHeader"
              [isFairEvalEnabledForStage]="hasPlacementFairEvalEnabled(item.offerId)"
              [ratingLevelTranslations]="ratingLevelTranslations"
              [abilities]="abilities"
            >
            </rt-interview-result-card>
          }
        }
      }
    }
  </div>
}
